import { FC, forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Modal, Button } from 'mk-pc'

interface Props {
  onConfirm?: (item: any) => void
}

/**
 * 删除确认框
 * @param props
 * @returns
 */
export const DeleteConfirm = forwardRef((props: Props, ref) => {
  const { onConfirm } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [visible, setVisible] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const deleteObj = useRef<any>(null)

  useImperativeHandle(ref, () => ({
    open: (message: string, item: any) => {
      setMessage(message || '删除当前记录，是否继续？')
      setVisible(true)
      deleteObj.current = item
    }
  }))

  /**
   * 关闭
   */
  const handleClose = () => {
    setVisible(false)
  }

  /**
   * 确认
   * @returns
   */
  const handleConfirm = async () => {
    if (!onConfirm) return

    setLoading(true)

    try {
      await onConfirm(deleteObj.current)
      setLoading(false)
      setVisible(false)
    } catch (e) {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={'删除提示'}
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="back" onClick={handleClose}>
          否，取消
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleConfirm}>
          是，删除
        </Button>
      ]}
    >
      <p>{message}</p>
    </Modal>
  )
})
